/**
 * Quyết định giao tiết kiệm chi
 * NXHinh 17.04.2025
 */
export default {
    Unit: 1,
    Budget: 2,
    UnitAndBudget: 3,
  };
  